import React from 'react';
import './studio-banner.m.css';
import LazyEagerImage from '../lazy-eager';

const StudioBanner = () =>
  <div styleName="studiobanner">
    <LazyEagerImage src="/assetify/IP-katso-ja-kuuntele-3.jpg" alt="Katso ja kuuntele"/>
  </div>

export {StudioBanner}
